const user = {
  getlist: 'user/getlist',
  add: 'user/add',
  update: 'user/update-by-admin',
  remove: 'user/remove',
  get: 'user/get-by-admin',
  getall: 'user/getall',
}
export default user
